import React, { useMemo } from "react";
import { BottomNavigation, BottomNavigationAction } from "@mui/material";
import ListIcon from "@mui/icons-material/List";
import FolderIcon from "@mui/icons-material/Folder";
import HomeIcon from "@mui/icons-material/Home";
import CalendarTodayIcon from "@mui/icons-material/CalendarToday";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import { useNavigate, useLocation } from "react-router-dom";
import useAcl from "../../hooks/useAcl";

const allItems = [
  { key: "calendar", icon: <CalendarTodayIcon />, route: "/calendar" },
  { key: "projects", icon: <FolderIcon />, route: "/projects" },
  { key: "home", icon: <HomeIcon />, route: "/" },
  { key: "tasks", icon: <ListIcon />, route: "/tasks" },
  { key: "profile", icon: <AccountCircleIcon />, route: "/profile" },
];

function getNavIndex(pathname: string, items: typeof allItems): number {
  if (pathname.startsWith("/calendar")) {
    const index = items.findIndex((item) => item.key === "calendar");
    return index >= 0 ? index : 0;
  }
  if (pathname.startsWith("/projects") || pathname.startsWith("/project/")) {
    const index = items.findIndex((item) => item.key === "projects");
    return index >= 0 ? index : 0;
  }
  if (pathname === "/") {
    const index = items.findIndex((item) => item.key === "home");
    return index >= 0 ? index : 0;
  }
  if (pathname.startsWith("/tasks") || pathname.startsWith("/task/")) {
    const index = items.findIndex((item) => item.key === "tasks");
    return index >= 0 ? index : 0;
  }
  if (pathname.startsWith("/profile")) {
    const index = items.findIndex((item) => item.key === "profile");
    return index >= 0 ? index : 0;
  }
  return 0;
}

const MobileNavigation: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { canRead: canReadProjects } = useAcl("Project");

  const items = useMemo(() => {
    return allItems.filter(
      (item) => item.key !== "projects" || canReadProjects !== false
    );
  }, [canReadProjects]);

  const value = getNavIndex(location.pathname, items);

  const handleChange = (_: React.SyntheticEvent, newValue: number) => {
    const targetRoute = items[newValue].route;

    if (value !== newValue) {
      navigate(targetRoute);
    }
  };

  return (
    <BottomNavigation
      value={value}
      onChange={handleChange}
      showLabels={false}
      sx={{
        position: "fixed",
        bottom: 0,
        left: 0,
        right: 0,
        width: "100%",
        boxShadow: "0 -1px 5px rgba(0,0,0,0.1)",
        backgroundColor: "#E0E6F0",
        zIndex: 1000,
      }}
    >
      {items.map((item) => (
        <BottomNavigationAction
          key={item.key}
          icon={item.icon}
          aria-label={item.key}
          sx={{
            minWidth: 0,
            "&.Mui-selected": {
              bgcolor: "#D0DDEE",
              color: "#222",
            },
          }}
        />
      ))}
    </BottomNavigation>
  );
};

export default MobileNavigation;
